import { IProgramacaoColetaAnalise } from "@/interfaces/IProgramacaoColetaAnalise";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface ProgramacaoState {
  items: IProgramacaoColetaAnalise[];
  synced: boolean;
}

const initialState: ProgramacaoState = {
  items: [],
  synced: false,
};

const programacaoColetaAnaliseSlice = createSlice({
  name: "PROGRAMACAO_COLETA_ANALISE",
  initialState,
  reducers: {
    sync: (
      state,
      action: PayloadAction<{ items: IProgramacaoColetaAnalise[] }>
    ) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default programacaoColetaAnaliseSlice.reducer;

export const getProgramacaoSynced = (state: RootState) =>
  state.programacaoColetaAnalise.items;
